import { Button, Form, Input, Select } from 'antd';
import React, { useEffect } from 'react';
import { useShops } from './ShopStore';
import { useTeams } from '../Teams/TeamStore';

function Add(props) {
    let { addShop } = useShops()
    let {teams, getTeams} = useTeams()
    useEffect(()=>{
        getTeams()
    }, [getTeams])
    return (
        <Form layout='vertical'
            onFinish={addShop}
        >
            <Form.Item name={'shopname'} label="Magazin nomi">
                <Input />
            </Form.Item>
            <Form.Item name={'address'} label="Manzili">
                <Input />
            </Form.Item>
            <Form.Item name={'phone'} label="Telefon raqami">
                <Input />
            </Form.Item>
            <Form.Item name={'seller_id'} label="Xodim">
                <Select options={teams.map(t => ({ value: t.id, label: t.name }))} />
            </Form.Item>
            <Form.Item>
                <Button type="primary" htmlType="submit">Qo'shish</Button>
            </Form.Item>
        </Form>
    );
}

export default Add;